import { ContributorType } from '@va/types/website';
import { getFullNameFromUserInfo } from '@va/util/helpers';

export function getFormattedContributorLists(contributors: ContributorType[]) {
  return contributors.map((contributor) => ({
    fullName: getFullNameFromUserInfo({
      firstName: contributor.user.firstName,
      lastName: contributor.user.lastName,
      email: contributor.user.email || 'N/A',
    }),
  }));
}
